import { QUESTION_TYPE } from "@/consts/survey";
import { JUMP_LOGIC_PATHS } from "@/consts/jumpLogic";

function getNPS(userResponse) {
  if (userResponse > 8) {
    return JUMP_LOGIC_PATHS.PROMOTER;
  } else if (userResponse > 6) {
    return JUMP_LOGIC_PATHS.PASSIVE;
  } else {
    return JUMP_LOGIC_PATHS.DETRACTOR;
  }
}

function getZeroToTen(userResponse) {
  if (userResponse > 8) {
    return JUMP_LOGIC_PATHS.PROMOTER;
  } else if (userResponse > 6) {
    return JUMP_LOGIC_PATHS.PASSIVE;
  } else {
    return JUMP_LOGIC_PATHS.DETRACTOR;
  }
}

function getOneToTen(userResponse) {
  if (userResponse > 6) {
    return JUMP_LOGIC_PATHS.PROMOTER;
  } else if (userResponse > 4) {
    return JUMP_LOGIC_PATHS.PASSIVE;
  } else {
    return JUMP_LOGIC_PATHS.DETRACTOR;
  }
}

function getOneToSeven(userResponse) {
  if (userResponse > 4) {
    return JUMP_LOGIC_PATHS.PROMOTER;
  } else if (userResponse > 3) {
    return JUMP_LOGIC_PATHS.PASSIVE;
  } else {
    return JUMP_LOGIC_PATHS.DETRACTOR;
  }
}

function getZeroToFive(userResponse) {
  if (userResponse > 3) {
    return JUMP_LOGIC_PATHS.PROMOTER;
  } else if (userResponse > 1) {
    return JUMP_LOGIC_PATHS.PASSIVE;
  } else {
    return JUMP_LOGIC_PATHS.DETRACTOR;
  }
}

function getOneToFive(userResponse) {
  if (userResponse > 3) {
    return JUMP_LOGIC_PATHS.PROMOTER;
  } else if (userResponse > 2) {
    return JUMP_LOGIC_PATHS.PASSIVE;
  } else {
    return JUMP_LOGIC_PATHS.DETRACTOR;
  }
}

export default function getUserContextByMetric(metricType, userResponse, minScale, maxScale) {
  switch (metricType) {
    case QUESTION_TYPE.CES:
    case QUESTION_TYPE.CES2:
    case QUESTION_TYPE.CSAT:
    case QUESTION_TYPE.EMOJI:
    case QUESTION_TYPE.RATINGS:
      if (minScale === 0 && maxScale === 10) {
        return getZeroToTen(userResponse);
      } else if (minScale === 1 && maxScale === 10) {
        return getOneToTen(userResponse);
      } else if (minScale === 1 && maxScale === 7) {
        return getOneToSeven(userResponse);
      } else if (minScale === 0 && maxScale === 5) {
        return getZeroToFive(userResponse);
      } else {
        return getOneToFive(userResponse);
      }
    case QUESTION_TYPE.NPS_RELATIONAL:
    case QUESTION_TYPE.NPS_TRANSACTIONAL:
      return getNPS(userResponse);
    case QUESTION_TYPE.THUMBS:
      if (userResponse > 0) {
        return JUMP_LOGIC_PATHS.PROMOTER;
      } else {
        return JUMP_LOGIC_PATHS.DETRACTOR;
      }
    default:
      return JUMP_LOGIC_PATHS.PASSIVE;
  }
}
